import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

import { LinkedTaskItem } from '../types/LinkedTaskItem';

export type UpdateLinkedTaskParams = {
  readonly id: string; // ID of exising linked task we are updating
  readonly scheduleId: string;
  readonly linkedTaskItems: LinkedTaskItem[];
}

export class UpdateLinkedTaskRequest extends Request<UpdateLinkedTaskParams, IEmptyResult> {
  constructor(params: UpdateLinkedTaskParams) {
    super('updateLinkedTask', params);
  }
}
